// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"5935": "5d43289e9327eec3","86667": "2c4da85964216fa3",}[chunkId] + ".css"
}